
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as SolutionsIconComponent } from "./solutions-icon.svg";

export const SolutionsIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <SolutionsIconComponent {...props} />;
};
